<template>
  <v-dialog :value="value" persistent max-width="800">
    <v-card>
      <v-card-title>
        <v-layout>
          <v-flex>
            <div class="title primary--text mt-2">Edit</div>
          </v-flex>
          <v-flex class="text-xs-right">
            <v-btn icon @click="$emit('input', false)" class="ma-0" :loading="loading">
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-layout wrap>
          <v-flex xs12 sm6 class="px-1">
            <div class="caption mb-2">code *</div>
            <v-text-field
              outline
              class="default-input"
              placeholder="Code"
              single-line
              v-validate="'required'"
              name="code"
              data-vv-as="Code"
              v-model="input.code"
              :error="errors.has('code') ? true : false"
              :error-messages="errors.has('code') ? errors.first('code') : ''"
            />
          </v-flex>
          <v-flex xs12 sm6 class="px-1">
            <div class="caption mb-2">Description *</div>
            <v-text-field
              outline
              class="default-input"
              placeholder="Description"
              single-line
              v-validate="'required'"
              name="description"
              data-vv-as="Description"
              v-model="input.description"
              :error="errors.has('description') ? true : false"
              :error-messages="errors.has('description') ? errors.first('description') : ''"
            />
          </v-flex>

          <v-flex xs12 sm6 class="px-1">
            <div class="caption mb-2">privilege *</div>
            <v-select
              :items="privileges"
              v-model="input.privilege"
              placeholder="Game"
              outline
              class="default-input"
              item-value="name"
              item-text="name"
              dense
              single-line
              clearable
              name="privilege"
              data-vv-as="privilege"
              v-validate="'required'"
              :error="errors.has('privilege') ? true : false"
              :error-messages="errors.has('privilege') ? errors.first('privilege') : ''"
            ></v-select>
          </v-flex>
        </v-layout>
        <div class="text-xs-center">
          <v-btn outline color="grey" @click="handleBack" :loading="loading">
            {{ $t('cancel') }}
          </v-btn>
          <v-btn color="primary" @click="handleSubmit" :loading="loading">
            {{ $t('Save') }}
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import generaliApi from '@/api/generali'
import { handleResponse, handleApiError } from '@/api/util'
export default {
  props: ['value', 'reward', 'privileges'],
  data() {
    return {
      loading: false,
      input: {
        code: '',
        description: '',
        drop_rate: '',
        privilege: ''
      }
    }
  },
  mounted() {
    if (this.reward) {
      this.input = this.reward
    }
  },
  methods: {
    handleBack() {
      this.$emit('input', false)
    },
    async handleSubmit() {
      const result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }
      this.loading = true
      try {
        const response = await generaliApi.patchReward({
          data: this.input,
          codeId: this.input.id,
          config: {}
        })
        handleResponse(response)
        this.$emit('handleSaveReward')
        this.$emit('input', false)
      } catch (error) {
        handleApiError(error)
      }
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/generalixwarroom/GameSetting/Reward/Manage.vue